import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import AttachFilesPDPAWidget from '../../widgets/attachfiles/AttachFilesPDPAWidget'
import BtnEditAll from '../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { getAttachments } from '../../redux/actions/attachments'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../utils/widget'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import pathname from '../../constants/pathname'

export default function AttachFilesPDPA() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  // http://localhost:3000/proposal/attach-files-pdpa/0DA9FD10-D046-4739-A82D-B26A17034EAD
  const mockSchema = {
    header: 'บทบาทของภาคีผู้รับทุน (PDPA)',
    subHeader: 'ข้อเสนอโครงการ พัฒนาและปฏิบัติการ 1',
    projecCode: null,
    projecName: null,
    disabled: false,
    formTemplate: 0,
    forms: {
      inputForms: {
        buttonText: 'อ่านคำอธิบายเพิ่มเติมเกี่ยวกับ PDPA',
        roleOfGrantreePDPA: {
          options: [
            {
              disabled: false,
              label: 'ผู้ควบคุมข้อมูลส่วนบุคคล (Data Controller)',
              value: 'data_controller',
            },
            {
              disabled: false,
              label: 'ผู้ประมวลผลข้อมูลส่วนบุคคล (Data Processor)',
              value: 'data_processor',
            },
          ],
          name: 'roleOfGrantreePDPA',
          label: 'บทบาทของภาคีผู้รับทุน (PDPA)',
          value: '',
          disabled: false,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาเลือกบทบาทของภาคีผู้รับทุน (PDPA)',
            },
          ],
        },
      },
      attachment: {
        header: 'บทบาทของภาคีผู้รับทุน (PDPA)',
        disabled: false,
        feedbackBySubject: null,
        buttonText: 'ไฟล์เอกสาร PDPA',
        attachFiles: {
          name: 'attachFiles',
          disabled: false,
          description: ['แนบไฟล์เอกสาร PDPA'],
          value: [
            {
              fileTypeId: '50',
              fileType: 'ข้อตกลงประมวลผลข้อมูลส่วนบุคคล (DPA)',
              uploadDate: '2022-08-27T10:27:55.297',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '7B0D4CD2-DFEF-43B9-BFC4-4EE64F43D0BC.pdf',
              name: '7B0D4CD2-DFEF-43B9-BFC4-4EE64F43D0BC.pdf',
              path: 'proposal/person-qualification/DFC4A744-EAC0-424F-B238-49C06FCD7FD2.pdf',
              type: null,
              size: 0,
              id: '2FFE28F2-36EA-43BD-883B-A49F50D89DA6',
            },
          ],
          id: null,
        },
      },
    },
  }

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const _schema = await getAttachments(projectId)
      // console.log('AttachFilesView => ', JSON.stringify(_schema))
      const _schema = mockSchema
      setSchema(_schema)
      setIsEditWidget({
        attachment: false,
      })

      // setIsEditWidget({
      //   attachment: _schema.forms?.attachment?.attachFiles?.value.length > 0 ? false : true,
      // })

      setShowEditAll(!_schema.forms?.attachment?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load AttachFilesView projectId', projectId)
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={1}>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {/* {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            routing={buttonRoute}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            editWidget={isEditWidget}
            forms={schema?.forms}
          />
        )} */}

        {schema?.forms?.attachment && (
          <>
            <AttachFilesPDPAWidget
              formDisabled={schema.forms.attachment.disabled}
              isEdit={isEditWidget.attachment}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('attachment', _isEdit, setIsEditWidget)
              }
              schema={schema.forms}
              header={schema.header}
              loadMenu={true}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
